import React from "react";
import { Router } from "@reach/router";
import HomePage from "../pages/home_page";
import ArticuloPage from "../pages/articulo_page";
import { ScrollToTop } from "./scroll_to_top";
import NuevoArticuloPage from '../pages/nuevo_articulo_page';
import AdminPage from "../pages/admin_page";
import moment from "moment";
import 'moment/locale/es';
import RevisionPage from '../pages/revision_page';
import LoginPage from "../pages/login_page";
import SearchPage from "../pages/search_page";
import MiCuentaPage from "../pages/mi_cuenta_page"

moment.locale('es');

const Main = () => {
  return (
    <Router>
      <ScrollToTop path="/">
        <HomePage default path="/" />
        <ArticuloPage path="articulo" />
        <ArticuloPage path="articulo/:nombre" />
        <SearchPage path="etiqueta/:tag" />
        <NuevoArticuloPage path="nuevo" />
        <SearchPage path="buscar" />
        <SearchPage path="buscar/:query" />
        <AdminPage path="admin" />
        <RevisionPage path="admin/revision/:id" />
        <LoginPage path="login" />
        <MiCuentaPage path="micuenta" />
      </ScrollToTop>
    </Router>
  );
};

export default Main;
